
export default {
    namespaced: true,
    state: {
        dataByCountry: [],
        currentPage: 1,
        totalRows: null,
        currentBrand: null,
        regions: null,
        searchEngine: 'google',
        columnHeader: {},
    },
    getters: {
        CURRENT_BRAND: state => {
            return state.currentBrand;
        },
        DATA_BY_COUNTRY: state => {
            return state.dataByCountry;
        },
        REGIONS: state => {
            return state.regions;
        },
        COLUMN_HEADER: state => {
            return state.columnHeader;
        },
        SEARCH_ENGINE: state => {
            return state.searchEngine;
        },
    },
    mutations: {
        CURRENT_BRAND: (state, payload) => {
            return state.currentBrand = payload;
        },
        DATA_BY_COUNTRY: (state, payload) => {
            return state.dataByCountry = payload;
        },
        REGIONS: (state, payload) => {
            return state.regions = payload;
        },
        COLUMN_HEADER: (state, payload) => {
            return state.columnHeader = payload;
        },
        SEARCH_ENGINE: (state, payload) => {
            return state.searchEngine = payload;
        },
    },
    actions: {
        GET_DATA: async ({state, commit}, payload) => {
            payload.th.showOverlay ++;
            // set null for rewrite vue component
            state.currentBrand = null
            payload.th.$forceUpdate()
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand-info/position/' + payload.id +'/'+ state.searchEngine,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('DATA_BY_COUNTRY', responseData.data);
                    commit('REGIONS', responseData.countryList);
                    commit('COLUMN_HEADER', responseData.columnHeader);
                    commit('CURRENT_BRAND', responseData.brand);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        UPDATE_POSITION: async ({state, dispatch}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand-info/position-update/' + payload.id +'/'+ state.searchEngine,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    console.log(responseData)
                    dispatch('GET_DATA', {id: payload.id, th: payload.th})
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        }
    }
}